import type {SVGProps, FC} from 'react';

export const JumpIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M20.0014 2H4.00143C2.90143 2 2.00143 2.9 2.00143 4V6.84003H4.00143V4H20.0014V16H6.00143L4.00143 18V13.335H2.00143V22L6.00143 18H20.0014C21.1114 18 22.0014 17.11 22.0014 16V4C22.0014 2.9 21.1114 2 20.0014 2ZM11.6966 14.95L10.3364 13.53L12.8174 10.95H1.99609V8.95003H12.8174L10.3364 6.36003L11.6966 4.95003L16.4863 9.95003L11.6966 14.95Z'
            />
        </svg>
    );
};

